import * as defaultImport from "@splunk/react-icons/LayersTriple";
export * from "@splunk/react-icons/LayersTriple";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
